var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "modal flex",
      class: _vm.className,
      style: { zIndex: _vm.zIndex },
      attrs: { transition: "fade" }
    },
    [
      _c("div", {
        staticClass: "modal-backdrop in",
        on: { click: _vm.clickBack }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-dialog", style: { width: _vm.width } }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _vm._t("content", [
              _vm._t("header", [
                _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _c("button", {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.close()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._t("title", [
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    ])
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
              _vm._v(" "),
              _vm._t("footer", [
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn dark btn-outline",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.close()
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    ),
                    _vm._v(" "),
                    _vm._t("button")
                  ],
                  2
                )
              ])
            ])
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }